import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import { MyDatePickerModule } from 'mydatepicker';

import { homeRouting } from './home.routing';
import { HomeComponent } from './home.component';

import { CookieService } from 'angular2-cookie/services/cookies.service';

import {
    ApiService,
    CustomerService,
    InvoiceService,
    QuoteService,
    AutoCompletionService,
    SearchService,
    PackService,
    ServService,
    BikeService,
    PostitService,
    SmsService,
    SocketService,
    MarketingService,
    LetterService,
    PosturalService,
    BikeService2,
    MagasinService,
    TasksService,
    NotPaidService,
    OrderService
} from './services';

import {
    ButtonsComponent,
    ButtonComponent,
    SearchComponent,
    TabsComponent,
    TableComponent,
    InputComponent,
    NumComponent,
    InputButtonComponent,
    InterestComponent,
    TextareaComponent,
    ModalComponent,
    SummaryComponent,
    ArticleComponent,
    ServiceComponent,
    PostitComponent,
    SmsComponent,
    SocketsmsComponent,
    TelComponent,
    LetterComponent,
    BikeModalComponent,
    OrderComponent
} from './components';

import {
    CustomerComponent,
    InvoiceComponent,
    QuoteComponent,
    PackComponent,
    PostitsComponent,
    BikeComponent,
    MarketingComponent,
    StatisticComponent,
    BikesComponent,
    OneBikeComponent,
    TasksComponent,
    NotPaidComponent,
    ExportComponent
} from './pages';

@NgModule({
    imports     : [
        CommonModule,
        FormsModule,
        homeRouting,
        MyDatePickerModule
    ],
    declarations: [
        HomeComponent,
        BikeComponent,
        PostitsComponent,
        PackComponent,
        CustomerComponent,
        TelComponent,
        InvoiceComponent,
        QuoteComponent,
        ButtonsComponent,
        ButtonComponent,
        SearchComponent,
        TabsComponent,
        TableComponent,
        InputComponent,
        NumComponent,
        InputButtonComponent,
        InterestComponent,
        TextareaComponent,
        ModalComponent,
        SummaryComponent,
        ArticleComponent,
        ServiceComponent,
        MarketingComponent,
        StatisticComponent,
        PostitComponent,
        SmsComponent,
        SocketsmsComponent,
        LetterComponent,
        BikesComponent,
        BikeModalComponent,
        OneBikeComponent,
        TasksComponent,
        NotPaidComponent,
        OrderComponent,
        ExportComponent
    ],
    providers   : [
        ApiService,
        ServService,
        SmsService,
        PosturalService,
        CustomerService,
        AutoCompletionService,
        InvoiceService,
        QuoteService,
        SearchService,
        PackService,
        BikeService,
        PostitService,
        SocketService,
        MarketingService,
        CookieService,
        LetterService,
        BikeService2,
        MagasinService,
        TasksService,
        NotPaidService,
        OrderService
    ],
    bootstrap   : [HomeComponent]
})
export class HomeModule {
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/home.module.ts